export const truncateString = (str, limit) => {
	if (str.length <= limit) {
		return str;
	}
	return str.slice(0, limit) + '...';
};

export const shuffleArray = (array) => {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
	return array;
};
